import { HANDLE_NAMES, DRAG_START, DRAG, DRAG_END, Cursors } from '../../constants.js';
import { canDrag } from './canDrag.js';

class ConnectionEditTool {
    constructor(toolService) {
        this.toolService = toolService;
        this.type = 'ConnectionTool';
    }
    tryActivate(_p, meta) {
        const toolService = this.toolService, diagram = toolService.diagram, selectable = diagram.options.selectable, item = toolService.hoveredItem, isActive = selectable !== false &&
            item && item.path && !(item.isSelected && meta.ctrlKey);
        if (isActive) {
            this._c = item;
        }
        return isActive;
    }
    start(p, meta) {
        const toolService = this.toolService;
        const connection = this._c;
        toolService.selectSingle(connection, meta);
        const adorner = connection.adorner;
        let handle, name;
        if (adorner) {
            handle = adorner._hitTest(p);
            name = HANDLE_NAMES[handle];
        }
        if (canDrag(connection) && adorner && !toolService.diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: name })) {
            this.handle = handle;
            this.handleName = name;
            adorner.start(p);
        }
        else {
            toolService.startPoint = p;
            toolService.end(p);
        }
    }
    move(p) {
        const adorner = this._c.adorner;
        if (canDrag(this._c) && adorner) {
            adorner.move(this.handle, p);
            this.toolService.diagram.trigger(DRAG, { shapes: [], connections: [this._c], connectionHandle: this.handleName });
            return true;
        }
    }
    end(p) {
        const connection = this._c;
        const adorner = connection.adorner;
        const toolService = this.toolService;
        const diagram = toolService.diagram;
        if (adorner) {
            if (canDrag(connection)) {
                const unit = adorner.stop(p);
                if (!diagram.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: this.handleName })) {
                    diagram.undoRedoService.add(unit, false);
                    connection.updateModel();
                    diagram._syncConnectionChanges();
                }
                else {
                    unit.undo();
                }
            }
        }
    }
    getCursor() {
        return Cursors.move;
    }
}

export { ConnectionEditTool };
